// removed by extract-text-webpack-plugin
module.exports = {"progress":"_1qfCOjIjIx78TiYT6k14Sb","requesting":"_2YAlxcuK09MgibAvp2snsL","container":"S3xFxkrCMG_Kim-pMbZlh","title_DD":"_2S2kyyQPJHW1ywsBFD6tEz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/password-recovery/PasswordRecovery.scss
// module id = 1641
// module chunks = 0